import { useEffect, useRef } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { useAuth } from '../AuthContext';
import api from '../api';
import { T } from '../styles/theme';

export default function AuthCallback() {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const { setUser } = useAuth();
  const done = useRef(false);

  useEffect(() => {
    if (done.current) return;
    done.current = true;

    const token = searchParams.get('token');
    if (token) {
      localStorage.setItem('token', token);
      localStorage.setItem('impero_jwt_token', token); // sync bridge estensione
      // Piccolo delay per assicurare che il token sia settato
      setTimeout(() => {
        api.get('/auth/me')
          .then(r => {
            if (r.data) {
              setUser(r.data);
              navigate('/dashboard', { replace: true });
            } else {
              navigate('/login', { replace: true });
            }
          })
          .catch(() => navigate('/login', { replace: true }));
      }, 300);
    } else {
      navigate('/login', { replace: true });
    }
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  return (
    <div style={{ minHeight: '100vh', background: T.bg, display: 'flex', alignItems: 'center', justifyContent: 'center', flexDirection: 'column', gap: 16 }}>
      <div style={{ width: 48, height: 48, borderRadius: '50%', border: `3px solid ${T.border}`, borderTopColor: T.violetDark, animation: 'spin 1s linear infinite' }} />
      <p style={{ fontFamily: T.fontBody, color: T.muted, fontSize: '0.9rem' }}>Accesso con Discord in corso...</p>
      <style>{`@keyframes spin { to { transform: rotate(360deg); } }`}</style>
    </div>
  );
}
